<template>
  <ul class="content-wrap">
    <li class="tem-item" v-for="(item, index) in list" :key="index" @click="selectFile(item)">
      <h3 class="text" :title="info.tag == 'tem'? item.templateName : item.name">{{ info.tag == 'tem'? item.templateName : item.name }}</h3>
      <div class="operate">
        <i class="iconfont icon-icon14" @click.stop="checkDelete(item)"></i>
      </div>
    </li>
  </ul>
</template>
<script>
import Bus from '@/assets/js/vueBus.js'
export default {
  props: {
    list: {
      type: Array,
      default () {
        return []
      }
    },
    info: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      fileInfo: {}
    }
  },
  created () {
    this.fileInfo = this.info
  },
  methods: {
    selectFile (item) {
      // if(this.info.tag == 'tem') {
      Bus.$emit('goTemplateBlank', {
        data: item,
        tag: this.info.tag,
        type: this.info.tag == 'tem' ? 'edit' : ''
      }, true)
      // }
    },
    checkDelete (item) {
      this.$confirm(this.$t('lang.deleteMediaList'), '', {
        confirmButtonText: this.$t('lang.Confirm'),
        cancelButtonText: this.$t('lang.cancel'),
        type: ''
      }).then(() => {
        if (this.fileInfo.tag == 'tem') {
          this.deleteTemplate(item)
        }
      }).catch(() => {})
    },
    deleteTemplate (item) {
      const Url = '/gatewayPlayoutUrl/tvu-playout/eventTemplate/delete'
      const params = {
        ids: [item.id]
      }
      this.axios.post(Url, params, { contentType: 'application/json;charset=UTF-8' }).then((res) => {
        if (res.data.errorCode == '0x0') {
          this.$message.success(this.$t('lang.deleteSuccess'))
          Bus.$emit('refreshTemList', this.info.tag)
        } else {
          this.$message.info(this.$t('lang.fileUsed'))
        }
      }).catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.content-wrap {
  width: 100%;
  // height: 28px;
  background: #444444;
  .tem-item {
    width: 100%;
    height: 28px;
    line-height: 28px;
    padding-left: 30px;
    padding-right: 20px;
    .text {
      height: 100%;
      width: 210px;
      line-height: 28px;
      font-size: 12px;
      color: #cccccc;
      text-align: left;
      margin: 0;
      float: left;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .operate {
      height: 100%;
      line-height: 28px;
      float: right;
      i {
        font-size: 13px;
      }
    }
    &:hover {
      background: #3f5d46;
      .operation {
        display: block;
      }
    }
  }
}
</style>
